import { render, staticRenderFns } from "./habitation-subscription.vue?vue&type=template&id=396a0dec&scoped=true"
import script from "./habitation-subscription.vue?vue&type=script&lang=js"
export * from "./habitation-subscription.vue?vue&type=script&lang=js"
import style0 from "./habitation-subscription.vue?vue&type=style&index=0&id=396a0dec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a0dec",
  null
  
)

export default component.exports